import "./thank-you-page.scss";

